import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  StyledContainerItems,
  StyledTitleSideBar,
  StyledContainerFooterSideBar,
  ButtonStyled
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../../i18n';
import { SideBarEditablePropertyItem } from '../../../../components/commons/SideBarComponents/EditablePropertyItem/sideBarEditablePropertyItem';
import { SideBarSimpleMethodItem } from '../../../../components/commons/SideBarComponents/SimpleMethodItem/sideBarSimpleMethodButtonItem';
import { ClearButtonForFilter } from '../../../../components/commons/SideBarComponents/ClearButtonForFilter/clearButtonForFilter';

interface AllLocationsFiltersProps {
  reloadTable: () => void;
  setOpenRightSideBar: (value: boolean) => void;
  openRightSideBar: boolean;
}
export const AllLocationsFilters = ({
  reloadTable,
  setOpenRightSideBar,
  openRightSideBar
}: AllLocationsFiltersProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const filterByLabel = queryParams.get('filterByLabel');
  const filterByOwner = queryParams.get('filterByOwner');
  const filterSharedWith = queryParams.get('filterSharedWith');
  const [filters, setFilters] = useState({
    filterByLabel: filterByLabel || '',
    filterByOwner: filterByOwner || '',
    filterSharedWith: filterSharedWith || ''
  });
  const closeSideBar = () => {
    setOpenRightSideBar(false);
  };

  const applyFilters = () => {
    const filterConfig = [
      {
        key: 'filterByLabel',
        value: filters.filterByLabel,
        useSelectedModel: false
      },
      {
        key: 'filterByOwner',
        value: filters.filterByOwner,
        useSelectedModel: false
      },
      {
        key: 'filterSharedWith',
        value: filters.filterSharedWith,
        useSelectedModel: false
      }
    ];

    filterConfig.forEach((filter) => {
      if (filter.value) {
        queryParams.set(filter.key, filter.value);
      } else {
        queryParams.delete(filter.key);
      }
    });

    navigate(`?${queryParams.toString()}`);
    reloadTable();
    closeSideBar();
  };

  const removeFilters = () => {
    const newUrl = window.location.pathname;
    navigate(newUrl);
    reloadTable();
    closeSideBar();
  };

  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>{Strings.common.filters}</StyledTitleSideBar>
        <ClearButtonForFilter
          filterName="filterByLabel"
          clearFilter={() => setFilters({ ...filters, filterByLabel: '' })}
          filters={filters}
        >
          <SideBarEditablePropertyItem
            item={{
              label: Strings.users.filterByTextLabel,
              type: 'inputText',
              currentValue: filters.filterByLabel,
              placeholder: '',
              nameAndId: 'firstName',
              onChange: (
                event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
              ) =>
                setFilters({
                  ...filters,
                  filterByLabel: event.target.value
                })
            }}
          />
        </ClearButtonForFilter>
        <ClearButtonForFilter
          filterName="filterByOwner"
          clearFilter={() => setFilters({ ...filters, filterByOwner: '' })}
          filters={filters}
        >
          <SideBarEditablePropertyItem
            item={{
              label: Strings.users.filterByOwnerLabel,
              type: 'inputText',
              currentValue: filters.filterByOwner,
              placeholder: '',
              nameAndId: 'filterByOwner',
              onChange: (
                event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
              ) =>
                setFilters({
                  ...filters,
                  filterByOwner: event.target.value
                })
            }}
          />
        </ClearButtonForFilter>
        <ClearButtonForFilter
          filterName="filterSharedWith"
          clearFilter={() => setFilters({ ...filters, filterSharedWith: '' })}
          filters={filters}
        >
          <SideBarEditablePropertyItem
            item={{
              label: Strings.users.filterBySharedWithLabel,
              type: 'inputText',
              currentValue: filters.filterSharedWith,
              placeholder: '',
              nameAndId: 'filterSharedWith',
              onChange: (
                event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
              ) =>
                setFilters({
                  ...filters,
                  filterSharedWith: event.target.value
                })
            }}
          />
        </ClearButtonForFilter>
        <SideBarSimpleMethodItem
          name={Strings.common.removeFilters}
          action={() => removeFilters()}
          successAction={false}
          textSuccess="success"
        />
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => closeSideBar()}
        >
          {Strings.common.cancel}
        </button>
        <ButtonStyled
          variant="contained"
          size="large"
          onClick={() => {
            applyFilters();
          }}
        >
          {Strings.common.save}
        </ButtonStyled>
      </StyledContainerFooterSideBar>
    </>
  );
};
